import React from 'react';
import {formatText} from 'presentation/utils';
import {useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {DatePickerHeaderProps} from '../../DatePickerHeader.types';
import {
	ButtonActionCalendar,
	Content,
	ButtonContainer,
	Container,
	DividerHeader,
	Title,
} from './styles';

const DatePickerHeaderMobile: React.FC<DatePickerHeaderProps> = ({
	month,
	year,
	onPrevMonth,
	onNextMonth,
	lang = 'pt-BR',
	disableButtonPrevMonth,
	disableButtonNextMonth,
}) => {
	const {colors} = useTheme();
	const monthName = new Date(`1970/${month}/01`).toLocaleString(lang, {
		month: 'long',
	});
	const monthNameFormatted = formatText(monthName);

	return (
		<Container>
			<Content>
				<Title>
					{monthNameFormatted} {year}
				</Title>
				<ButtonContainer>
					<ButtonActionCalendar
						type="button"
						onClick={onPrevMonth}
						disabled={disableButtonPrevMonth}>
						<Icon name="chevron-left-outlined" color={colors.light.text.primary} />
					</ButtonActionCalendar>
					<DividerHeader />
					<ButtonActionCalendar
						type="button"
						onClick={onNextMonth}
						disabled={disableButtonNextMonth}>
						<Icon name="chevron-right-outlined" color={colors.light.text.primary} />
					</ButtonActionCalendar>
				</ButtonContainer>
			</Content>
		</Container>
	);
};

export {DatePickerHeaderMobile};
